import Swal from "sweetalert2";
import moment from "moment-timezone";
export const handleAssignDriverToTransfer = async (
  transferId,
  {
    setAssigningDriverToTransfer,
    transfersData,
    driversData,
    fetchData,
    cars,
    rentals,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  try {
    setAssigningDriverToTransfer(transferId);

    // Find transfer details
    const transfer = transfersData.find((t) => t._id === transferId);
    if (!transfer) {
      throw new Error("Transfer not found");
    }

    // Filter drivers by vehicle type compatibility
    const compatibleDrivers = driversData.filter(
      (driver) =>
        driver.vehicleTypes.includes(transfer.carType) && driver.isActive
    );

    if (compatibleDrivers.length === 0) {
      await Swal.fire({
        icon: "warning",
        title: "No Compatible Drivers",
        text: `No active drivers available for vehicle type: ${transfer.carType}`,
        confirmButtonColor: "#1e3a8a",
      });
      return;
    }

    // Create driver selection options
    const driverOptions = compatibleDrivers.map((driver) => {
      return {
        value: driver._id,
        text: `${driver.name} ${driver.surname} (${driver.phone})`,
      };
    });

    // Create a dropdown with the options
    const { value: driverId, dismiss } = await Swal.fire({
      title: "Assign Driver",
      html: `
          <div class="mb-3">
            <p class="text-sm text-left mb-1">Transfer: ${
              transfer.pickupLocation
            } → ${transfer.dropoffLocation}</p>
            <p class="text-sm text-left">Date: ${moment(
              transfer.pickUpDate
            ).format("DD/MM/YYYY")} at ${transfer.pickupHours}:${
        transfer.pickupMinutes
      }</p>
          </div>
          <div class="mb-3">
            <label for="driverSelect" class="block text-sm font-medium text-left mb-1">Select Driver:</label>
            <select id="driverSelect" class="w-full px-3 py-2 border rounded-md">
              ${driverOptions
                .map(
                  (option) =>
                    `<option value="${option.value}">${option.text}</option>`
                )
                .join("")}
            </select>
          </div>
          <div class="mb-3">
            <label for="driverNotes" class="block text-sm font-medium text-left mb-1">Notes for driver:</label>
            <textarea id="driverNotes" class="w-full px-3 py-2 border rounded-md" placeholder="Special instructions for the driver..."></textarea>
          </div>
        `,
      showCancelButton: true,
      confirmButtonText: "Assign",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#1e3a8a",
      preConfirm: () => {
        const driverId = document.getElementById("driverSelect").value;
        const driverNotes = document.getElementById("driverNotes").value;
        return { driverId, driverNotes };
      },
    });

    if (dismiss) return;

    // Assign the driver
    await drivers.assignDriver(
      transferId,
      driverId.driverId,
      driverId.driverNotes
    );

    await Swal.fire({
      icon: "success",
      title: "Success",
      text: "Driver assigned successfully",
      confirmButtonColor: "#1e3a8a",
    });

    fetchData();
  } catch (error) {
    console.error("Error assigning driver:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to assign driver. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setAssigningDriverToTransfer(null);
  }
};
